<template>
  <b-modal
    ref="change-location-modal"
    id="change-location-modal"
    class="change-location-modal"
    hide-header
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <div
      class="d-flex justify-content-between top-modal"
      style="margin-top: 10px;"
    >
      <div>
        <h4 class="font-medium text-primary">
          Edit Location
        </h4>
        <!--        <p class="mb-0 text-placeholder">-->
        <!--          Set a new bid for selected ad groups in selected campaigns.-->
        <!--        </p>-->
      </div>
      <div>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideModal"
        />
      </div>
    </div>
    <div
      v-if="loading"
      class="d-flex justify-content-center py-3"
    >
      <b-spinner
        variant="secondary"
        small
      />
    </div>
    <div
      v-else
      class="choose-video-content my-2"
    >
      <div class="d-flex justify-content-between">
        <label class="form-label d-flex align-items-center">
          Location
        </label>
        <p
          class="underline text-blue font-14 cursor-pointer"
          @click="chooseAllLocation"
        >
          Select all
        </p>
      </div>
      <treeselect
        v-model="locationSelected"
        :multiple="true"
        :options="locationOptions"
      />
      <small
        v-if="locationSelected.length === 0"
        class="text-danger d-block mt-25"
      >The Location is required</small>
    </div>

    <!-- Action Buttons -->
    <template #modal-footer>
      <div class="d-flex justify-content-end">
        <btn-loading
          class="mr-1 border-0"
          variant-convert="btn-back"
          pill
          @click="hideModal"
        >
          Cancel
        </btn-loading>
        <btn-loading
          class="ml-1"
          variant-convert="btn-submit"
          type="submit"
          pill
          :disabled="locationSelected.length === 0"
          @click="confirmSelection"
        >
          Apply
        </btn-loading>
      </div>
    </template>
  </b-modal>
</template>
<script>
import {
  BModal, BSpinner,
} from 'bootstrap-vue'
import BtnLoading from '@/layouts/components/BtnLoading.vue'
import campaignMixin from '@/mixins/campaignMixin'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { createNamespacedHelpers } from 'vuex'

const { mapGetters } = createNamespacedHelpers('campaign')

export default {
  components: {
    BSpinner,
    Treeselect,
    BModal,
    BtnLoading,
  },
  mixins: [campaignMixin],
  props: {
    campaigns: {
      type: Array,
      default: () => [],
      required: true,
    },

    adAccountSelected: {
      type: Object,
      default: () => ({}),
      required: true,
    },

    locationOptions: {
      type: Array,
      default: () => [],
      required: true,
    },
  },
  data() {
    return {
      locationSelected: [],

      currentAdGroup: null,
      currentCampaignIndex: null,
      currentAdGroupIndex: null,
      scheduleType: 'SCHEDULE_FROM_NOW', // or 'SCHEDULE_START_END'

      startDate: null,
      rangeDate: null,
      now: new Date(),

      messageErrorDate: '',
      messageErrorRangeDate: '',
    }
  },

  computed: {
    ...mapGetters(['status', 'message', 'loading']),

  },

  methods: {
    initData() {
      if (this.currentAdGroup) {
        this.locationSelected = this.currentAdGroup?.adgroup?.locationIds
      }
    },

    resetModal() {
      this.currentAdGroup = null
    },

    hideModal() {
      this.$refs['change-location-modal'].hide()
      this.resetModal()
    },

    async showModal(campaignIndex, adgroupIndex) {
      // Set current ad group from passed parameters
      this.currentCampaignIndex = campaignIndex
      this.currentAdGroupIndex = adgroupIndex

      if (campaignIndex !== null && adgroupIndex !== null) {
        const campaign = this.campaigns[campaignIndex]
        const adgroup = campaign?.adgroupList[adgroupIndex]

        this.currentAdGroup = {
          campaignIndex,
          adgroupIndex,
          adgroup,
        }

        this.initData()
      }

      this.$refs['change-location-modal'].show()
    },

    chooseAllLocation() {
      this.locationSelected = this.locationOptions.map(location => location.id)
    },

    confirmSelection() {
      const campaignIndex = this.currentAdGroup?.campaignIndex
      const adgroupIndex = this.currentAdGroup?.adgroupIndex
      const adgroup = this.campaigns[campaignIndex]?.adgroupList[adgroupIndex]
      adgroup.locationIds = this.locationSelected
      this.hideModal()
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
#change-location-modal {
  .modal-content {
    .modal-body {
      height: 100%;
    }

    .vue-treeselect__control {
      height: 38px;
      border-radius: 12px;
    }

    .form-control:focus, .input-group:focus-within .form-control {
      border-color: #e0e0e5 !important;
    }

    .vue-treeselect__multi-value {
      max-height: 162px;
      overflow-y: scroll;
    }

    .vue-treeselect__x-container, .vue-treeselect__control-arrow-container {
      vertical-align: top;
      padding-top: 12px;
    }
  }
}
</style>
